module.exports = __webpack_public_path__ + "static/media/zyzt.70bbcac.wav";


//////////////////
// WEBPACK FOOTER
// ./src/static/voice/zyzt.wav
// module id = SYbv
// module chunks = 1